import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import 'svg2pdf.js';

export async function generateInvoice(user, visitEntry, visitNumber) {
  const doc = new jsPDF();

  const companyName = "Preventive Pest Terminators";
  const tagline = "ISO 9001:2015 & FoSTaC Certified";
  const companyAddress = "Plot No-3/13, Hissa No-1180, Krushnamai Society,\nTaljai Pathar, Dhankawadi, Pune - 411043";
  const contactNo = "+91 87888 95445";

  // Document Settings
  const pageWidth = doc.internal.pageSize.width;

  // Brand Header Background
  doc.setFillColor(23, 75, 53); // Primary brand color
  doc.rect(0, 0, pageWidth, 45, 'F');
  
  // Real Website SVG Logo (Shield)
  const svgStr = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 62">
      <defs>
        <linearGradient id="shield" x1="8" y1="3" x2="50" y2="59" gradientUnits="userSpaceOnUse">
          <stop stop-color="#a9d957" />
          <stop offset=".46" stop-color="#76ad43" />
          <stop offset="1" stop-color="#174b35" />
        </linearGradient>
      </defs>
      <path d="M28 3 50 12v17c0 14-9 25-22 30C15 54 6 43 6 29V12L28 3Z" fill="url(#shield)" />
      <path d="M17 21c8-7 19-7 25 0-4 11-11 17-14 20-4-3-8-10-11-20Z" fill="#a9d957" />
      <path d="M28 17v25M20 29h16" stroke="#174b35" stroke-width="3" stroke-linecap="round" />
    </svg>
  `;
  const parser = new DOMParser();
  const svgElement = parser.parseFromString(svgStr.trim(), "image/svg+xml").documentElement;
  
  await doc.svg(svgElement, {
    x: 14,
    y: 11,
    width: 14,
    height: 15.5
  });
  
  // Header Text
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(22);
  doc.setFont("helvetica", "bold");
  doc.text(companyName, 32, 19.5);
  
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text(tagline, 32, 26.5);

  // Right aligned Header info
  doc.setFontSize(10);
  doc.text("TAX INVOICE / RECEIPT", pageWidth - 14, 20, { align: 'right' });

  // Reset text color for body
  doc.setTextColor(50, 50, 50);

  // Company Details
  doc.setFontSize(10);
  doc.setFont("helvetica", "bold");
  doc.text("From:", 14, 60);
  doc.setFont("helvetica", "normal");
  doc.text(companyAddress, 14, 66);
  doc.text(`Phone: ${contactNo}`, 14, 76);

  // Bill To Details
  doc.setFont("helvetica", "bold");
  doc.text("Bill To:", pageWidth - 80, 60);
  doc.setFont("helvetica", "normal");
  const customerName = `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'Customer';
  doc.text(customerName, pageWidth - 80, 66);
  doc.text(`Phone: ${user.contact || 'N/A'}`, pageWidth - 80, 71);
  if (user.email) doc.text(`Email: ${user.email}`, pageWidth - 80, 76);

  const isMaster = Array.isArray(visitEntry);
  const visits = isMaster ? visitEntry : [visitEntry];
  
  // Invoice Meta Info
  const invoiceDate = isMaster 
    ? (visits.length > 0 ? `${new Date(visits[visits.length - 1].date).toLocaleDateString('en-IN')} - ${new Date(visits[0].date).toLocaleDateString('en-IN')}` : new Date().toLocaleDateString('en-IN'))
    : new Date(visitEntry.date).toLocaleDateString('en-IN');
    
  const invoiceId = `INV-${Date.now().toString().slice(-6)}-${isMaster ? 'ALL' : visitNumber}`;
  
  doc.setDrawColor(200, 200, 200);
  doc.line(14, 85, pageWidth - 14, 85);
  
  doc.setFont("helvetica", "bold");
  doc.text(`Invoice Number:`, 14, 95);
  doc.setFont("helvetica", "normal");
  doc.text(invoiceId, 45, 95);
  
  doc.setFont("helvetica", "bold");
  doc.text(isMaster ? `Service Period:` : `Date of Service:`, 14, 102);
  doc.setFont("helvetica", "normal");
  doc.text(invoiceDate, 45, 102);
  
  // Services Table
  let tableData = [];
  let totalBill = 0;
  
  if (isMaster) {
    visits.forEach((v, vIndex) => {
      const vDate = new Date(v.date).toLocaleDateString('en-IN');
      totalBill += Number(v.billAmount || 0);
      const servicesStr = (v.services || []).join(', ') || 'General Pest Control Service';
      tableData.push([
        vIndex + 1,
        `${vDate}: ${servicesStr}`,
        "-",
        `Rs. ${Number(v.billAmount || 0).toLocaleString()}`
      ]);
    });
  } else {
    totalBill = Number(visitEntry.billAmount || 0);
    tableData = (visitEntry.services || []).map((service, i) => [
      i + 1,
      service,
      "-",
      i === 0 ? `Rs. ${totalBill.toLocaleString()}` : 'Included'
    ]);
    if (tableData.length === 0) {
      tableData.push([1, "General Pest Control Service", "-", `Rs. ${totalBill.toLocaleString()}`]);
    }
  }

  autoTable(doc, {
    startY: 110,
    head: [['#', 'Description of Service', 'Rate', 'Amount']],
    body: tableData,
    theme: 'grid',
    headStyles: { fillColor: [23, 75, 53], textColor: 255 },
    styles: { font: 'helvetica', fontSize: 10, cellPadding: 5 },
    columnStyles: {
      0: { cellWidth: 15, halign: 'center' },
      2: { cellWidth: 30, halign: 'center' },
      3: { cellWidth: 40, halign: 'right' }
    }
  });

  // Total Section
  const finalY = doc.lastAutoTable.finalY + 15;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  
  const label = "Total Amount Received: ";
  const amountStr = `Rs. ${totalBill.toLocaleString()}`;
  const labelWidth = doc.getTextWidth(label);
  const amountWidth = doc.getTextWidth(amountStr);
  const startX = pageWidth - 14 - (labelWidth + amountWidth);

  doc.setTextColor(50, 50, 50); // Dark grey/black for label
  doc.text(label, startX, finalY);
  
  doc.setTextColor(20, 160, 100); // Green for the actual amount
  doc.text(amountStr, startX + labelWidth, finalY);

  // Notes / Terms
  doc.setTextColor(100, 100, 100);
  doc.setFontSize(9);
  doc.setFont("helvetica", "normal");
  if (!isMaster && visitEntry.notes) {
    doc.text("Service Notes:", 14, finalY + 15);
    doc.text(doc.splitTextToSize(visitEntry.notes, pageWidth - 30), 14, finalY + 20);
  }

  // Footer
  const footerY = doc.internal.pageSize.height - 20;
  doc.setFontSize(8);
  doc.setTextColor(150, 150, 150);
  doc.text("This is a computer-generated receipt and does not require a physical signature.", pageWidth / 2, footerY, { align: 'center' });
  doc.text("Thank you for choosing Preventive Pest Terminators!", pageWidth / 2, footerY + 5, { align: 'center' });

  // Save PDF
  const filename = `PPT_Receipt_${customerName.replace(/\s+/g, '_')}_${invoiceDate.replace(/\//g, '-')}.pdf`;
  doc.save(filename);
}
